export const PAD_V2_CONTAINER = 'PAD_V2_CONTAINER';
export const PAD_V2_CONTAINER_SELECTOR = '#PAD_V2_CONTAINER';
